(function () {
  'use strict';

  function cfgLog()  { if (window.cfgDebug) { try { console.log.apply(console, arguments); }  catch (e) {} } }
  function cfgWarn() { if (window.cfgDebug) { try { console.warn.apply(console, arguments); } catch (e) {} } }

  // Hardcoded — admin product handle for the Personalization Upgrade product. Used to
  // distinguish "upgrade tier" from "case" when deciding whether to show the confirm
  // dialog. If a merchant changes the handle, update here.
  var UPGRADE_HANDLE = 'personalization-upgrade';
  var CONFIRM_MESSAGE = 'Removing the personalization upgrade will also remove your customized case (it can\'t be made without the upgrade). Continue?';

  // Re-entry guard so orphan cleanup doesn't loop on its own cart:change dispatch.
  var orphanCleanupInProgress = false;

  function isCartPage() {
    return (window.themeVariables && window.themeVariables.settings && window.themeVariables.settings.pageType === 'cart')
      || window.location.pathname === '/cart';
  }

  // Read the cart-drawer section's Shopify-assigned ID from the live DOM. Mirrors the
  // theme's extractSectionId helper pattern (theme.js.liquid:150-153). Returns null if
  // the drawer isn't on the current page (e.g., we're on /cart).
  function getCartDrawerSectionId() {
    var drawer = document.querySelector('cart-drawer');
    if (!drawer) return null;
    var section = drawer.closest('.shopify-section');
    if (!section || !section.id) return null;
    return section.id.replace(/^shopify-section-/, '');
  }

  function getLinkedLineItems() {
    return Array.prototype.slice.call(document.querySelectorAll('line-item[data-linked-group]'));
  }

  function groupByLinkedGroup(items) {
    var groups = {};
    items.forEach(function (item) {
      var key = item.dataset.linkedGroup;
      if (!key) return;
      if (!groups[key]) groups[key] = [];
      groups[key].push(item);
    });
    return groups;
  }

  // Mirror the theme's existing busy state: <pill-loader> child of <line-item> takes
  // aria-busy="true" while a change is in flight (theme.js.liquid:1860-1865). We also
  // dispatch line-item:will-change so the theme's own UI hooks fire naturally.
  function setProcessingState(lineItems, isProcessing) {
    lineItems.forEach(function (item) {
      var loader = item.querySelector('pill-loader');
      if (loader) {
        if (isProcessing) loader.setAttribute('aria-busy', 'true');
        else loader.removeAttribute('aria-busy');
      }
      if (isProcessing) {
        item.dispatchEvent(new CustomEvent('line-item:will-change', {
          bubbles: true,
          detail: { targetQuantity: 0 }
        }));
      }
    });
  }

  // POST /cart/update.js with one or more line keys → quantity 0. The `updates` object
  // form removes multiple lines atomically. `sections` is included only when the cart
  // drawer is on the page so the response carries rendered section HTML.
  function updateMultipleLines(lineKeys, includeSections) {
    var updates = {};
    lineKeys.forEach(function (key) { updates[key] = 0; });
    var body = { updates: updates };
    if (includeSections) {
      var sectionId = getCartDrawerSectionId();
      if (sectionId) body.sections = [sectionId];
    }
    cfgLog('[linked-removal] Calling /cart/update.js with keys:', lineKeys, 'sections:', body.sections || 'none');
    return fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(body)
    })
      .then(function (response) {
        cfgLog('[linked-removal] /cart/update.js responded, status:', response.status);
        if (!response.ok) {
          throw new Error('Cart update failed: HTTP ' + response.status);
        }
        return response.json();
      });
  }

  function dispatchCartChange(cartData) {
    document.documentElement.dispatchEvent(new CustomEvent('cart:change', {
      bubbles: true,
      detail: { baseEvent: 'line-item:change', cart: cartData }
    }));
  }

  function handleLinkedRemoveClick(e, lineItem, linkedGroup) {
    e.preventDefault();
    e.stopImmediatePropagation();

    cfgLog('[linked-removal] Linked remove intercepted, group:', linkedGroup, 'product handle:', lineItem.dataset.productHandle);

    var selector = 'line-item[data-linked-group="' + (window.CSS && CSS.escape ? CSS.escape(linkedGroup) : linkedGroup) + '"]';
    var partners = Array.prototype.slice.call(document.querySelectorAll(selector));
    cfgLog('[linked-removal] Found', partners.length, 'partner(s) in group');
    if (partners.length === 0) return;

    var isUpgradeClick = lineItem.dataset.productHandle === UPGRADE_HANDLE;
    if (isUpgradeClick && partners.length > 1) {
      if (!window.confirm(CONFIRM_MESSAGE)) {
        cfgLog('[linked-removal] User cancelled upgrade removal');
        return;
      }
    }

    setProcessingState(partners, true);

    var lineKeys = partners.map(function (p) { return p.dataset.lineKey; }).filter(Boolean);
    var includeSections = !isCartPage();
    updateMultipleLines(lineKeys, includeSections)
      .then(function (data) {
        cfgLog('[linked-removal] Update succeeded, new item count:', data.item_count);
        if (isCartPage()) {
          window.location.href = '/cart';
        } else {
          dispatchCartChange(data);
        }
      })
      .catch(function (err) {
        console.error('[linked-removal] Failed:', err);
        setProcessingState(partners, false);
      });
  }

  // Orphan cleanup: any data-linked-group whose group has only one DOM member is a
  // dangling line. Silent removal + cart:change dispatch. Re-entry guarded.
  function cleanupOrphans() {
    if (orphanCleanupInProgress) {
      cfgLog('[linked-removal] cleanupOrphans already in progress, skipping');
      return;
    }
    var items = getLinkedLineItems();
    cfgLog('[linked-removal] cleanupOrphans running, found', items.length, 'linked line-item(s)');
    if (items.length === 0) {
      cfgLog('[linked-removal] No linked line-items in DOM, exiting');
      return;
    }
    var groups = groupByLinkedGroup(items);
    var orphanKeys = [];
    Object.keys(groups).forEach(function (groupId) {
      var members = groups[groupId];
      cfgLog('[linked-removal] Group', groupId, 'has', members.length, 'member(s)');
      if (members.length === 1) {
        // Only a FEE line without its parent is a true orphan. A case/wallet line
        // without a fee sibling is a legitimate purchase (content-gated fees mean
        // fee-less groups are normal) — any other handle, including undefined,
        // is kept. Fail-safe direction is always "keep".
        if (members[0].dataset.productHandle === UPGRADE_HANDLE) {
          var key = members[0].dataset.lineKey;
          if (key) {
            orphanKeys.push(key);
            cfgWarn('[linked-removal] Orphan detected, group:', groupId, 'key:', key);
          }
        } else {
          cfgLog('[linked-removal] Single-member group', groupId, 'is not the upgrade product — keeping');
        }
      }
    });
    if (orphanKeys.length === 0) {
      cfgLog('[linked-removal] No orphans, exiting');
      return;
    }

    orphanCleanupInProgress = true;
    updateMultipleLines(orphanKeys, !isCartPage())
      .then(function (data) {
        cfgLog('[linked-removal] Orphan cleanup removed', orphanKeys.length, 'item(s), new item count:', data.item_count);
        if (isCartPage()) {
          window.location.reload();
        } else {
          dispatchCartChange(data);
        }
      })
      .catch(function (err) {
        console.error('[linked-removal] Orphan cleanup failed:', err);
      })
      .then(function () {
        orphanCleanupInProgress = false;
      });
  }

  // Document-level CAPTURE-PHASE click listener. Fires before any target-phase or
  // bubble-phase listener on <line-item-quantity> (theme.js.liquid:1993). Two-strategy
  // line-item resolution: (a) closest() works for cart drawer where the remove link is a
  // descendant of <line-item>; (b) URL line-key lookup works for /cart where the remove
  // link sits in a sibling <td> (main-cart.liquid:59) outside the <line-item> element.
  document.addEventListener('click', function (e) {
    var link = e.target.closest && e.target.closest('a[href*="/cart/change"]');
    if (!link) return;

    var url;
    try { url = new URL(link.href, window.location.origin); }
    catch (err) { return; }
    if (url.searchParams.get('quantity') !== '0') return;

    // Strategy 1: link is inside a line-item (cart drawer pattern).
    var strategy = 'closest';
    var lineItem = link.closest('line-item');

    // Strategy 2: link is outside line-item, find by URL line key (/cart page pattern).
    if (!lineItem) {
      strategy = 'url-key';
      var lineKey = url.searchParams.get('id');
      if (lineKey) {
        lineItem = document.querySelector('line-item[data-line-key="' + (window.CSS && CSS.escape ? CSS.escape(lineKey) : lineKey) + '"]');
      }
    }

    if (!lineItem) return;
    var linkedGroup = lineItem.dataset.linkedGroup;
    if (!linkedGroup) return;

    cfgLog('[linked-removal] Linked remove intercepted via', strategy, '— group:', linkedGroup);
    handleLinkedRemoveClick(e, lineItem, linkedGroup);
  }, true);

  // Orphan cleanup hooks. With <script defer>, this IIFE runs after DOM parse but before
  // DOMContentLoaded — readyState is 'interactive', so the else branch fires immediately.
  // line-items are already in the DOM since defer waited for parse completion.
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', cleanupOrphans);
  } else {
    cleanupOrphans();
  }
  document.addEventListener('cart:change', function () {
    setTimeout(cleanupOrphans, 100);
  });

  cfgLog('[linked-removal] Module loaded, capture-phase remove listener attached, readyState:', document.readyState);
})();
